<template>
  <main class="mall_main max-w-[1200px] mx-auto mb-20">
    <header>
      <div></div>
      <h1 class="font-bold">콘텐츠 몰</h1>

      <div class="mall_search_wr mr-4 gap-2" >
        <label class="flex items-center border-r border-neutral-400 pr-2 gap-1">
          <select v-model="selectedCategoryId" class="text-sm bg-transparent appearance-none">
            <option value="" hidden>카테고리</option>
            <option :value="category.categoryId" v-for="category in categoryList" :key="category.categoryId">
              {{category.categoryName}}
            </option>
          </select>
          <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.592761 0.000606174C0.670711 0.000246611 0.74795 0.0150999 0.819944 0.0442945C0.891939 0.0734892 0.95724 0.116437 1.01202 0.170619L4.54799 3.62496L8.08396 0.193801C8.19546 0.123176 8.32801 0.0911665 8.46035 0.102903C8.5927 0.11464 8.71718 0.169443 8.81384 0.258529C8.9105 0.347615 8.97375 0.465824 8.99345 0.594211C9.01314 0.722599 8.98815 0.853729 8.92246 0.966584L4.96724 4.8305C4.856 4.93904 4.70521 5 4.54799 5C4.39077 5 4.23997 4.93904 4.12873 4.8305L0.173507 0.966585C0.0624046 0.857912 -1.2917e-07 0.710601 -1.42597e-07 0.55701C-1.56025e-07 0.403419 0.0624045 0.256107 0.173507 0.147435C0.287996 0.0464373 0.438666 -0.0063289 0.592761 0.000606174Z" fill="black"/>
          </svg>
        </label>

        <label class="flex items-center gap-2">
          <input v-model="searchQuery" type="text" placeholder="검색어를 입력하세요." @keyup.enter="handleSearch(1)"/>

          <button type="button" @click="searchItemList">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
          </button>
        </label>
      </div>
        {{ searchQuery }}
    </header>

    <div class="overflow-auto max-lg:px-4 max-lg:pb-4 shop_top_menu">
      <nav class="xl:min-w-[768px]">
        <router-link :to="{ path: '/mall' }" active-class="current" @click="CateClick()">홈</router-link>
        <router-link 
          v-for="category in categoryList" :key="category.categoryId"
          :to="'/mall/'+ category.categoryId" active-class="current"
          @click="CateClick(category.categoryId)">
          {{category.categoryName}}
        </router-link>
      </nav>
    </div>

    <!-- 홈 -->
    <div v-if="$route.path === '/mall'">
      <!-- 슬라이드 -->
      <div class="slide_wr">
        <!-- loop="true" -->
        <swiper-container 
          navigation="true"
          pagination="true"
          autoplay-delay="4000"
        >
          <swiper-slide>
            <img src="@/assets/img/main_confImg_hana2.jpg" alt=""/>
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/main_confImg_hana.jpg" alt=""/>
          </swiper-slide>
          <swiper-slide>
            <img src="@/assets/img/main_confImg.jpg" alt=""/>
          </swiper-slide>
  
          <!-- Navigation -->
          <div class="swiper-button-prev ml-7"></div>
          <div class="swiper-button-next mr-7"></div>
        </swiper-container>
      </div>
  
      <section class="mall_section">
        <h3 class="flex gap-2 font-bold items-center mb-6">
          신규 콘텐츠
          <svg width="42" height="20" viewBox="0 0 42 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="42" height="20" rx="10" fill="#FFA800"/>
            <path d="M14.7578 5.51562V14H13.3984L9.37891 8.19922H9.30859V14H7.78516V5.51562H9.16797L13.1641 11.3164H13.2461V5.51562H14.7578ZM16.3281 14V5.51562H21.8477V6.79297H17.8516V9.11328H21.5547V10.3906H17.8516V12.7109H21.8711V14H16.3281ZM25.1055 14L22.7148 5.51562H24.3555L25.8906 11.7617H25.9727L27.6016 5.51562H29.1016L30.7422 11.7734H30.8125L32.3477 5.51562H33.9883L31.5977 14H30.0859L28.3867 8.03516H28.3281L26.6172 14H25.1055Z" fill="white"/>
          </svg>
        </h3>
        <!-- 상품 그리드 -->
        <menu class="product_grid_container">
          <li v-if="loading === false" v-for="content in itemList.slice(0, 4)" :key="content.itemId"  class="product_grid_wr">
            <!-- 상품 thumb -->
            <div class="product_thumb">
              <router-link :to="'/mall/view/' + content.itemId">
                <img
                v-if="content.thumbnailLink"
                :src="'https://eduwind-api.nodeblack.net/' + content.thumbnailLink"
                :alt="content.title"
              />
              <img
                v-else
                src="@/assets/img/null_img.jpg"
                :alt="content.title"
              />
              </router-link>
              <!-- thumb 마우스오버 레이어 -->
              <div></div>
              <span>
                <!-- 장바구니 -->
                <button @click="addCart(content.itemId)" class="block w-fit h-fit">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23" fill="none">
                    <path d="M4.06672 0.9H4.06669H1.76667C1.53752 0.9 1.31732 0.989031 1.15462 1.14819C0.991857 1.30741 0.9 1.52385 0.9 1.75C0.9 1.97615 0.991857 2.19259 1.15462 2.35181C1.31732 2.51097 1.53752 2.6 1.76667 2.6H3.39103L6.29282 13.9562C6.29282 13.9562 6.29283 13.9562 6.29283 13.9563C6.33985 14.1407 6.44844 14.3039 6.6008 14.4204C6.75314 14.5369 6.9406 14.5999 7.13336 14.6H7.13339H20.9335C21.1263 14.5999 21.3138 14.5369 21.4661 14.4204C21.6185 14.3039 21.7271 14.1406 21.7741 13.9562L24.0741 4.95626L24.0741 4.95621C24.1061 4.83064 24.1085 4.69955 24.081 4.57294C24.0535 4.44634 23.9969 4.32769 23.9157 4.22597C23.8345 4.12425 23.7308 4.04215 23.6127 3.98574C23.4945 3.92933 23.3649 3.90004 23.2336 3.9H5.50904L4.90727 1.54379C4.90727 1.54379 4.90727 1.54378 4.90726 1.54378C4.90726 1.54377 4.90726 1.54376 4.90726 1.54375C4.86023 1.35936 4.75165 1.19607 4.59929 1.07959C4.44695 0.963136 4.25948 0.900052 4.06672 0.9ZM7.80905 12.9L5.94348 5.6H22.1234L20.2579 12.9H7.80905ZM7.65243 18.0108C7.92107 17.748 8.28589 17.6 8.66674 17.6C9.04759 17.6 9.4124 17.748 9.68105 18.0108C9.94962 18.2736 10.1001 18.6294 10.1001 19C10.1001 19.3706 9.94962 19.7264 9.68105 19.9892C9.4124 20.252 9.04759 20.4 8.66674 20.4C8.28589 20.4 7.92107 20.252 7.65243 19.9892C7.38386 19.7264 7.23339 19.3706 7.23339 19C7.23339 18.6294 7.38386 18.2736 7.65243 18.0108ZM6.42833 16.8072C5.83422 17.3884 5.50004 18.1771 5.50004 19C5.50004 19.8229 5.83422 20.6116 6.42833 21.1928C7.02236 21.7739 7.82758 22.1 8.66674 22.1C9.5059 22.1 10.3111 21.7739 10.9051 21.1928C11.4993 20.6116 11.8334 19.8229 11.8334 19C11.8334 18.1771 11.4993 17.3884 10.9051 16.8072C10.3111 16.2261 9.5059 15.9 8.66674 15.9C7.82758 15.9 7.02236 16.2261 6.42833 16.8072ZM18.3859 18.0108C18.6545 17.748 19.0193 17.6 19.4002 17.6C19.781 17.6 20.1458 17.748 20.4145 18.0108C20.6831 18.2736 20.8335 18.6294 20.8335 19C20.8335 19.3706 20.6831 19.7264 20.4145 19.9892C20.1458 20.252 19.781 20.4 19.4002 20.4C19.0193 20.4 18.6545 20.252 18.3859 19.9892C18.1173 19.7264 17.9668 19.3706 17.9668 19C17.9668 18.6294 18.1173 18.2736 18.3859 18.0108ZM17.1618 16.8072C16.5677 17.3884 16.2335 18.1771 16.2335 19C16.2335 19.8229 16.5677 20.6116 17.1618 21.1928C17.7558 21.7739 18.561 22.1 19.4002 22.1C20.2393 22.1 21.0445 21.7739 21.6386 21.1928C22.2327 20.6116 22.5669 19.8229 22.5669 19C22.5669 18.1771 22.2327 17.3884 21.6386 16.8072C21.0445 16.2261 20.2393 15.9 19.4002 15.9C18.561 15.9 17.7558 16.2261 17.1618 16.8072Z" fill="white" stroke="white" stroke-width="0.2"/>
                  </svg>
                </button>
                <!-- 다운로드 -->
                <!-- <button>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M10 15.5L3.75 9.25L5.5 7.4375L8.75 10.6875V0.5H11.25V10.6875L14.5 7.4375L16.25 9.25L10 15.5ZM2.5 20.5C1.8125 20.5 1.22375 20.255 0.733752 19.765C0.243752 19.275 -0.000831211 18.6867 2.12224e-06 18V14.25H2.5V18H17.5V14.25H20V18C20 18.6875 19.755 19.2762 19.265 19.7662C18.775 20.2562 18.1867 20.5008 17.5 20.5H2.5Z" fill="white"/>
                  </svg>
                </button> -->
              </span>
            </div>
  
            <!-- 상품설명 -->
            <div class="product_desc">
              <div class="flex gap-1">
                <span v-for="tag in content.tagList" :key="tag.tagId"  class="product_sub_tt">{{tag}}</span>
              </div>

              <router-link :to="'/mall/view/' + content.itemId"  class="product_tt">{{content.title}}</router-link>
              
              <div v-if="content.isFree === false">
                <div v-if="content.regularPrice === content.sellingPrice" class="flex gap-1 product_price">
                  {{content.sellingPrice.toLocaleString()}}원
                </div>
                <div v-else class="flex gap-1 product_price">
                  <strong>{{content.discountRate.toLocaleString()}}%</strong>
                  {{content.sellingPrice.toLocaleString()}}원
                  <p>{{content.regularPrice.toLocaleString()}}원</p>
                </div>
              </div>
              <div v-else>
                <b>무료</b>
              </div>

              <div  class="product_tags mt-2">
                <span>
                  {{ content.itemKind }}
                </span>
              </div>
            </div>
          </li>
        </menu>
      </section>
  
      <section>
        <h3 class="font-bold text-center pt-10">
          용품·교재 판매처
        </h3>
        <div class="flex gap-2 mx-auto mt-6 justify-center max-lg:flex-col">
          <a href="">
            <img src="@/assets/img/mallMain_link1.png" alt="총회교육몰 바로가기" class="mx-auto">
          </a>
          <a href="">
            <img src="@/assets/img/mallMain_link2.png" alt="홀리원북 바로가기" class="mx-auto">
          </a>
        </div>
      </section>
    </div>
    


    <!-- 카테고리 -->
    <div v-else  class="mall_cate_container">
      <ul class="mall_cate_left">
        <!-- <h3 class="font-bold mb-4">{{ categoryName }}</h3> -->
        <li class="current">전체</li>
        <li v-for="cate in categoryList2" :key="cate.categoryId">{{cate.categoryName}}</li>
      </ul>

      <div class="w-full max-w-5xl flex flex-col">
        <!-- <div class="flex gap-4 bg-neutral-100 p-6 mb-10 text-sm">
          <label>
            <input type="checkbox"/> 3과정 2학기
          </label>
          <label>
            <input type="checkbox"/> 3과정 1학기
          </label>
        </div> -->

        <!--
        <div class="text-sm" v-if="!searched">
          <div class="bg-neutral-100 border border-neutral-200 p-4 mt-2">
            <div class="lg:flex items-center">
              <span class="w-20">기간조회</span>
              <VDatePicker v-model.range="range" locale="ko" :max-date='new Date()'>
                <template #default="{ inputValue, inputEvents }">
                  <div class="flex justify-center items-center">
                    <input type="text" class="regi_inputs w-full" :value="inputValue.start" v-on="inputEvents.start" />
                    <span class="mx-2">~</span>
                    <input type="text" class="regi_inputs w-full" :value="inputValue.end" v-on="inputEvents.end" />
                    
                    <button class="ml-2 sec_filled-blk_btn p-2 flex-1" type="button" @click="getContentsList">조회</button>
                  </div>
                </template>
              </VDatePicker>
            </div>
          </div>
        </div>
        -->

        <div class="flex items-center justify-between py-6">
          <div class="text-sm text-gray-500">
            총 {{pageInfo.total}}개
          </div>

          <select v-model="selectedSort" @change="getContentsList" v-if="!searched"
            class="block border border-neutral-200 p-1 rounded text-sm max-xl:mr-6">
            <option value="latest">최신순</option>
            <option value="seller">판매순</option>
            <option value="price">가격낮은순</option>
          </select>

          <select v-model="selectedSort" @change="searchItemList" v-else
          class="block border border-neutral-200 p-1 rounded text-sm max-xl:mr-6">
          <option value="latest">최신순</option>
          <option value="seller">판매순</option>
          <option value="price">가격낮은순</option>
        </select>
        </div>


        <!-- 상품 그리드 -->
        <menu v-if="itemList.length > 0" class="product_grid_container product_grid_container_smaller">
          <li v-if="loading === false" v-for="content in itemList" :key="content.itemId"  class="product_grid_wr">
            <!-- 상품 thumb -->
            <div class="product_thumb">
              <router-link :to="'/mall/view/' + content.itemId">
                <img
                v-if="content.thumbnailLink"
                :src="'http://118.67.134.110:18080' + content.thumbnailLink"
                :alt="content.title"
                />
                <img
                  v-else
                  src="@/assets/img/null_img.jpg"
                  :alt="content.title"
                />
              </router-link>
              <!-- thumb 마우스오버 레이어 -->
              <div></div>
              <span>
                <!-- 장바구니 -->
                <button @click="addCart(content.itemId)" class="block w-fit h-fit">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23" fill="none">
                    <path d="M4.06672 0.9H4.06669H1.76667C1.53752 0.9 1.31732 0.989031 1.15462 1.14819C0.991857 1.30741 0.9 1.52385 0.9 1.75C0.9 1.97615 0.991857 2.19259 1.15462 2.35181C1.31732 2.51097 1.53752 2.6 1.76667 2.6H3.39103L6.29282 13.9562C6.29282 13.9562 6.29283 13.9562 6.29283 13.9563C6.33985 14.1407 6.44844 14.3039 6.6008 14.4204C6.75314 14.5369 6.9406 14.5999 7.13336 14.6H7.13339H20.9335C21.1263 14.5999 21.3138 14.5369 21.4661 14.4204C21.6185 14.3039 21.7271 14.1406 21.7741 13.9562L24.0741 4.95626L24.0741 4.95621C24.1061 4.83064 24.1085 4.69955 24.081 4.57294C24.0535 4.44634 23.9969 4.32769 23.9157 4.22597C23.8345 4.12425 23.7308 4.04215 23.6127 3.98574C23.4945 3.92933 23.3649 3.90004 23.2336 3.9H5.50904L4.90727 1.54379C4.90727 1.54379 4.90727 1.54378 4.90726 1.54378C4.90726 1.54377 4.90726 1.54376 4.90726 1.54375C4.86023 1.35936 4.75165 1.19607 4.59929 1.07959C4.44695 0.963136 4.25948 0.900052 4.06672 0.9ZM7.80905 12.9L5.94348 5.6H22.1234L20.2579 12.9H7.80905ZM7.65243 18.0108C7.92107 17.748 8.28589 17.6 8.66674 17.6C9.04759 17.6 9.4124 17.748 9.68105 18.0108C9.94962 18.2736 10.1001 18.6294 10.1001 19C10.1001 19.3706 9.94962 19.7264 9.68105 19.9892C9.4124 20.252 9.04759 20.4 8.66674 20.4C8.28589 20.4 7.92107 20.252 7.65243 19.9892C7.38386 19.7264 7.23339 19.3706 7.23339 19C7.23339 18.6294 7.38386 18.2736 7.65243 18.0108ZM6.42833 16.8072C5.83422 17.3884 5.50004 18.1771 5.50004 19C5.50004 19.8229 5.83422 20.6116 6.42833 21.1928C7.02236 21.7739 7.82758 22.1 8.66674 22.1C9.5059 22.1 10.3111 21.7739 10.9051 21.1928C11.4993 20.6116 11.8334 19.8229 11.8334 19C11.8334 18.1771 11.4993 17.3884 10.9051 16.8072C10.3111 16.2261 9.5059 15.9 8.66674 15.9C7.82758 15.9 7.02236 16.2261 6.42833 16.8072ZM18.3859 18.0108C18.6545 17.748 19.0193 17.6 19.4002 17.6C19.781 17.6 20.1458 17.748 20.4145 18.0108C20.6831 18.2736 20.8335 18.6294 20.8335 19C20.8335 19.3706 20.6831 19.7264 20.4145 19.9892C20.1458 20.252 19.781 20.4 19.4002 20.4C19.0193 20.4 18.6545 20.252 18.3859 19.9892C18.1173 19.7264 17.9668 19.3706 17.9668 19C17.9668 18.6294 18.1173 18.2736 18.3859 18.0108ZM17.1618 16.8072C16.5677 17.3884 16.2335 18.1771 16.2335 19C16.2335 19.8229 16.5677 20.6116 17.1618 21.1928C17.7558 21.7739 18.561 22.1 19.4002 22.1C20.2393 22.1 21.0445 21.7739 21.6386 21.1928C22.2327 20.6116 22.5669 19.8229 22.5669 19C22.5669 18.1771 22.2327 17.3884 21.6386 16.8072C21.0445 16.2261 20.2393 15.9 19.4002 15.9C18.561 15.9 17.7558 16.2261 17.1618 16.8072Z" fill="white" stroke="white" stroke-width="0.2"/>
                  </svg>
                </button>
                <!-- 다운로드 -->
                <!-- <button>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M10 15.5L3.75 9.25L5.5 7.4375L8.75 10.6875V0.5H11.25V10.6875L14.5 7.4375L16.25 9.25L10 15.5ZM2.5 20.5C1.8125 20.5 1.22375 20.255 0.733752 19.765C0.243752 19.275 -0.000831211 18.6867 2.12224e-06 18V14.25H2.5V18H17.5V14.25H20V18C20 18.6875 19.755 19.2762 19.265 19.7662C18.775 20.2562 18.1867 20.5008 17.5 20.5H2.5Z" fill="white"/>
                  </svg>
                </button> -->
              </span>
            </div>
  
            <!-- 상품설명 -->
            <div class="product_desc">
              <div class="flex gap-1">
                <span v-for="tag in content.tagList" :key="tag.tagId"  class="product_sub_tt">{{tag}}</span>
              </div>

              <router-link :to="'/mall/view/' + content.itemId"  class="product_tt">
                {{content.title}}
              </router-link>
              
              <div v-if="content.isFree === false">
                <div v-if="content.regularPrice === content.sellingPrice" class="flex gap-1 product_price">
                  {{content.sellingPrice.toLocaleString()}}원
                </div>
                <div v-else class="flex gap-1 product_price">
                  <strong>{{content.discountRate.toLocaleString()}}%</strong>
                  {{content.sellingPrice.toLocaleString()}}원
                  <p>{{content.regularPrice.toLocaleString()}}원</p>
                </div>
              </div>
              <div v-else>
                무료
              </div>

              <div  class="product_tags mt-2">
                <span>
                  {{ content.itemKind }}
                </span>
              </div>
            </div>
          </li>
        </menu>

        <menu class="text-center" v-else>
          <li>목록이 없습니다.</li>
        </menu>

        <pagination v-if="pageInfo.page"
          :pageInfo="pageInfo"
          :page="getPage"
          :size="size"
          @updatePage="updatePage"
        />

      </div>
    </div>
  </main>
</template>

<script setup>
  import { onMounted, ref, watchEffect, computed } from 'vue';
  import axios from 'axios';
  import router from "@/router";
  import { useRoute } from 'vue-router';
  const route = useRoute();

  import Pagination from '@/components/Pagination.vue';
  import { editCart } from '@/assets/js/cart.js';

  const categoryList = ref([]);
  const categoryList2 = ref([]);

  const loading = ref(true);

  const itemList = ref([]);

  const formatDate = (date) => date.toISOString().split('T')[0];

  const start = new Date();
  const end = new Date();
  start.setDate(end.getDate() - 90);

  const range = ref({ start, end });

  const formStartDate = computed(() => formatDate(range.value.start));
  const formEndDate = computed(() => formatDate(range.value.end));

  // 상품 검색 및 정렬
  const searchQuery = ref('');
  const selectedSort = ref('latest');
  const selectedCategoryId = ref('');
  const searched = ref(false);
  const pageUnitSize = 5;

  // const category = route.params.category;

  // 카테고리 리스트
  const getCategoryList = async (parentId = null) => {
    try {
      const res = await axios.get(`/new_api/category/list/simple${parentId ? `?parentId=${parentId}` : ''}`);
      if (parentId) {
        categoryList2.value = res.data.data.categoryList;
      } else {
        categoryList.value = res.data.data.categoryList;
      }
    } catch (error) {
      console.error(error);
    } finally {
      searched.value = false;
    }
  };

  let pageInfo = ref({});
  let getPage = ref(1);
  let size = ref(12);


  // 상품 리스트
  const getContentsList = async (cateId, num) => {
    const page = num !== undefined ? 1 : getPage.value;
    cateId = cateId || ''
    const itemType = '';

    try {
      loading.value = true;
      let sortOrder = '';

      if (selectedSort.value === 'price') {
        sortOrder = 'asc';
      }

      let apiUrl = `/new_api/customer/item/list?page=${page}`;
      apiUrl += ( size.value ) ? `&size=${size.value}`:'';
      apiUrl += ( selectedSort.value ) ? `&prop=${selectedSort.value}`:'';
      apiUrl += ( sortOrder ) ? `&dir=${sortOrder}`:'';
      apiUrl += ( pageUnitSize ) ? `&pageUnitSize=${pageUnitSize}`:'';
      apiUrl += ( searchQuery.value ) ? `&title=${searchQuery.value}`:'';
      apiUrl += ( itemType ) ? `&itemType=${itemType}`:'';
      apiUrl += ( cateId ) ? `&categoryId=${cateId}`:'';
      // apiUrl += ( formStartDate.value ) ? `&startDate=${formStartDate.value}`:'';
      // apiUrl += ( formEndDate.value ) ? `&endDate=${formEndDate.value}`:'';
      // `/new_api/customer/content/list?page=${page}&size=${size.value}&startDate=${formStartDate.value}&endDate=${formEndDate.value}&prop=${selectedSort.value}&dir=${sortOrder}&rootCategoryId=${cateId}`

      // console.log(apiUrl);

      const { data, status } = await axios.get(apiUrl);

      console.log(data);

      itemList.value = data.data.itemList;
      pageInfo.value = data.data.pageInfo;
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
      searched.value = false;
    }
  };

  const updatePage = (num) => {
    getPage.value = num;
    if(searched.value === true) {
      searchItemList();
    } else {
      getContentsList();
    }
  };

  const CateClick = async (cateId) => {
    searched.value = false;
    getPage.value = 1;
    await getCategoryList(cateId);
    await getContentsList(cateId);
  };


  // 장바구니 추가
  const addCart = (itemId) => {
    editCart(
      itemId,
      1,
      true,
      'CREATE'
    ).then((res) => {
      console.log(res)
      if (res.data.code === '200') {
        alert('장바구니에 담겼습니다.');
        router.push({ name: 'cart' }); // 장바구니 이동 여부 묻도록 변경할 것
      }
    });
  }



  const searchItemList = async (num, pageNum) => {
    let pageValue;

    if (pageNum) {
      pageValue = pageNum;
    } else {
      pageValue = num !== undefined ? 1 : getPage.value;
    }

    if (!searchQuery.value) {
      alert("검색어를 입력해 주세요.");
      return;
    }
    /*if (!selectedCategoryId.value) {
      alert("검색 카테고리를 선택해 주세요.");
      return;
    }*/
      
    try {
      loading.value = true;
      let sortOrder = '';
      
      await router.push(`/mall/${selectedCategoryId.value}`);

      if (selectedSort.value === 'price') {
        sortOrder = 'asc';
      }

      let url = `/new_api/customer/item/list?page=${pageValue}`;
      url += ( size.value ) ? `&size=${size.value}`:'';
      url += ( selectedSort.value ) ? `&prop=${selectedSort.value}`:'';
      url += ( sortOrder ) ? `&dir=${sortOrder}`:'';
      url += ( pageUnitSize ) ? `&pageUnitSize=${pageUnitSize}`:'';
      url += ( selectedCategoryId.value ) ? `&categoryId=${selectedCategoryId.value}`:'';
      // url += ( itemType ) ? `&itemType=${itemType}`:'';
      url += ( searchQuery.value ) ? `&title=${searchQuery.value}`:'';
      // url += ( startDate ) ? `&startDate=${startDate}`:'';
      // url += ( endDate ) ? `&endDate=${endDate}`:'';
      console.log(url);

      const res = await axios.get(url);
      itemList.value = res.data.data.itemList;
      pageInfo.value = res.data.data.pageInfo;
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
} ;

  const handleSearch = async (pageNum) => {
    await searchItemList(pageNum);
    await getCategoryList(selectedCategoryId.value); // 2차 카테고리 GET
    searched.value = true;
  };


  onMounted(async () => {
    await getCategoryList(); // 1차 카테고리 GET
    await getCategoryList(route.params.category); // 2차 카테고리 GET
    await getContentsList(); // 상품목록 GET
  });

  watchEffect(() => [itemList.value, categoryList.value, categoryList2.value], () => {
    loading.value = false;
  });
</script>

<style>
.shop_top_menu {
  scrollbar-width: thin;
}

</style>

